import Vue from 'vue';
import App from './App.vue';
import Vuex from 'vuex';
import store from './store';
import axios from 'axios';

import vuetify from '@/plugins/vuetify'; // path to vuetify export

import InstantSearch from 'vue-instantsearch';
import PrismicVue from '@prismicio/vue';
import { linkResolver } from './linkResolver';

import router from './router';
import VueMeta from 'vue-meta';
import { showInstallPromotion } from '@/plugins/pwa-install';

// import { initSurvicate, getSurvicateInstance, ApiEvent } from '@survicate/survicate-web-surveys-wrapper/widget_wrapper';
// const config = { workspaceKey: '2a4d6f6436724d527bd85e04db99bd98' };

//   await initSurvicate(config).then(() => {
//     const survicate = getSurvicateInstance();
//     survicate.addEventListener(ApiEvent.questionAnswered, () => console.log('questionAnswered'));
// })
const axiosConfig = {
  baseURL: process.env.VUE_APP_API_URL + '/' + process.env.VUE_APP_API_VERSION,
  timeout: 60000,
};

Vue.prototype.$axios = axios.create(axiosConfig);

// Default vars set up from VueCookie
// Vue.prototype.$axios.defaults.headers.common.Authorization = `Bearer ${VueCookie.get(
//   'token'
// )}`;
Vue.use(Vuex);

Vue.use(InstantSearch);
Vue.use(PrismicVue, {
  endpoint: 'measure-academy.prismic.io',
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/service-worker.js')
    .then(() => {
      console.log('Service Worker registered successfully.');
    })
    .catch((error) => {
      console.log('Service Worker registration failed:', error);
    });
}

Vue.use(VueMeta);
Vue.prototype.$showInstallPromotion = showInstallPromotion;

// eslint-disable-next-line no-new
new Vue({
  vuetify,
  router,
  store,
  render: (h) => h('v-app', [h(App)]),
}).$mount('#app');
